<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col>
          <b-card header="Basis gegevens">
            <b-form @submit.prevent="submitForm" autocomplete="off">
              <b-row>
                <b-col cols="12">
                  <h5>Basisgegevens</h5>
                  <hr>
                </b-col>
                <b-col cols="12" md="4">
                  <b-form-group label="Naam">
                    <b-form-input type="text" required v-model="Company.name" :disabled="!editable" autocomplete="off"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" md="2">
                  <b-form-group label="Relatienummer">
                    <b-form-input type="text" required v-model="Company.relation_number" :disabled="!editable" autocomplete="off"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="2">
                  <b-form-group label="Mapnummer">
                    <b-form-input type="text" required v-model="Company.map_number" :disabled="!editable" autocomplete="off"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" md="2">
                  <b-form-group label="Prijs per tik (in €)">
                    <b-form-input type="number" step="0.01" min="0.00" required v-model="Company.pricing" :disabled="!editable" autocomplete="off"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="mt-4">
                <b-col cols="12">
                  <h5>Contactgegevens</h5>
                  <hr>
                </b-col>
                <b-col cols="12" md="3">
                  <b-form-group label="E-mail">
                    <b-form-input type="text" required v-model="Company.email" :disabled="!editable" autocomplete="off"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="3">
                  <b-form-group label="Telefoonnummer">
                    <b-form-input type="text" v-model="Company.phone" :disabled="!editable" autocomplete="off"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="mt-4">
                <b-col cols="12">
                  <h5>Adresgegevens</h5>
                  <hr />
                </b-col>
                <b-col cols="12" md="4">
                  <b-form-group label="Straat + huisnummer">
                    <b-form-input type="text" v-model="Company.street" :disabled="!editable" autocomplete="off"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" md="2">
                  <b-form-group label="Postcode">
                    <b-form-input type="text" v-model="Company.postal_code" :disabled="!editable" autocomplete="off"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="2">
                  <b-form-group label="Stad">
                    <b-form-input type="text" v-model="Company.city" :disabled="!editable" autocomplete="off"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="mt-4">
                <b-col cols="12">
                  <h5>Authorisatiecodes</h5>
                  <hr>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" md="4">
                  <b-form-group label="CheckSociaal">
                    <b-form-input :type="editable ? 'text' : 'password'" v-model="Sites.check_sociaal.auth" :disabled="!editable" autocomplete="new-password"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="3" v-if="Sites.check_sociaal.username">
                  <b-form-group label="Experian ID">
                    <b-form-input type="text" v-model="Sites.check_sociaal.username" :disabled="true"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="3" v-if="Sites.check_sociaal.auth">
                  <b-form-group label="Actie">
                    <b-button type="button" @click.prevent="decodeUsername('check_sociaal')" variant="light" :disabled="isBusy">
                      {{Sites.check_sociaal.username ? 'Verberg' : 'Toon'}} Experian ID
                    </b-button>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <hr>
              </b-row>
              <b-row>
                <b-col cols="12" md="4">
                  <b-form-group label="VerhuurSignaal">
                    <b-form-input :type="editable ? 'text' : 'password'" v-model="Sites.verhuur_signaal.auth" :disabled="!editable" autocomplete="new-password"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="3" v-if="Sites.verhuur_signaal.username">
                  <b-form-group label="Experian ID">
                    <b-form-input type="text" v-model="Sites.verhuur_signaal.username" :disabled="true"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="3" v-if="Sites.verhuur_signaal.auth">
                  <b-form-group label="Actie">
                    <b-button type="button" @click.prevent="decodeUsername('verhuur_signaal')" variant="light" :disabled="isBusy">
                      {{Sites.verhuur_signaal.username ? 'Verberg' : 'Toon'}} Experian ID
                    </b-button>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <hr>
                  <div v-if="editable">
                    <b-button type="submit" variant="success" class="pull-right" :disabled="isBusy">
                      <b-spinner v-show="isBusy" small type="grow" />
                      Opslaan
                    </b-button>
                    <b-button type="button" @click.prevent="editable = isBusy = false" class="pull-right mr-2" variant="warning">
                      Annuleren
                    </b-button>
                  </div>
                  <div v-else>
                    <b-button type="button" @click.prevent="editable = true" class="pull-right" variant="primary">
                      Bewerken
                    </b-button>
                  </div>
                </b-col>
              </b-row>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import { getData, storeData, updateData } from '../../api';

export default {
  name: 'company',
  data() {
    return {
      isBusy: false,
      editable: false,
      Company: [],
      Sites: {
        check_sociaal: {
          id: 2,
          auth: '',
          username: null,
        },
        verhuur_signaal: {
          id: 1,
          auth: '',
          username: null,
        }
      },
      members: [],
    }
  },
  methods: {
    async getCompanyData() {
      const { id } = this.$route.params;
      return await getData(`companies/${id}`).then((response) => {
        const { data: { data } } = response;

        this.Company = data;
        this.Sites = this.parseSites(data.sites);
      });
    },
    async getCustomersData() {
      return await getData(`customers`).then(({ data }) => {
        this.customers = data.data;
      })
    },
    async submitForm() {
      this.editable = false;
      this.isBusy = true;

      const { id } = this.$route.params;
      const data = this.Company;
      const sites = this.Sites;

      if (sites) {
        await Object.keys(sites).forEach(async (item) => {
          await this.updateCompanySite(id, sites[item]);
        });
      }

      return await updateData(`companies/${id}`, data)
        .then((response) => {
          const { data: { data } } = response;

          this.Company = data;
          this.Sites = this.parseSites(data.sites);

          this.isBusy = false;
          this.$bvToast.toast('Item succesvol aangepast', {
            title: 'Succes',
            variant: 'success',
          });
        }).catch(error => {
          console.log('Error: ', error);
          this.isBusy = false;
        });
    },
    async updateCompanySite(company, site) {
      const { id, auth } = site;
      return await storeData(`companies/${company}/sites/${id}`, {
        auth
      }).catch(error => {
        console.log('Error: ', error);
        this.isBusy = false;
      });
    },
    parseSites(sites) {
      const collection = this.Sites;

      if (typeof sites !== 'undefined' && sites && sites.length > 0) {
        for (let key in collection) {
          const site = sites.find(item => item.type === key);

          if (site && site.auth) collection[key].auth = site.auth;
          else collection[key].auth = '';
        }
      }

      return collection;
    },
    decodeUsername(key) {

      if (!key) return;
      if (!this.Sites[key] || !this.Sites[key].auth) return;

      const site = this.Sites[key];

      if (!site.username) {
        const decoded = atob(site.auth).split(':');
        this.Sites[key].username = decoded[0];
      } else {
        this.Sites[key].username = null;
      }
    }
  },
  beforeMount() {
    this.getCustomersData().then(() => {
      this.getCompanyData();
    });
  }
}

</script>
